<template>
  <div>
    <div style="margin: 4px">
      <v-card class="mb-12">
        <v-card-text>
          <v-data-table :headers="headers" :items="prices">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title class="headline">Despesa</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  depressed
                  color="secondary"
                  class="mb-2"
                  @click="dialogPrice = true"
                  :disabled="disabledButton"
                >
                  <v-icon left class="theme--light">
                    mdi-plus
                  </v-icon>
                  Novo
                </v-btn>
                <v-dialog persistent v-model="dialogDelete" max-width="320px">
                  <v-card>
                    <v-card-title class="title"
                      >Deseja apagar esses<br />valores?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="default" text @click="closeDelete"
                        >Não</v-btn
                      >
                      <v-btn color="secondary" text @click="deleteItemConfirm"
                        >Sim</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.unitPrice="{ item }">
              R$ {{ item.unitPrice | currencyMask }}
            </template>

            <template v-slot:item.totalPrice="{ item }">
             R$ {{ (item.quantity * item.unitPrice).toFixed(2) | currencyMask }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>

            <template v-slot:body.append v-if="prices.length">
              <tr>
                <td :colspan="3" class="font-weight-bold">
                  Despesa Total
                </td>
                <td :colspan="2" class="font-weight-bold">
                  R$ {{ projectTotalPrice | currencyMask }}
                </td>
              </tr>
            </template>

            <template v-slot:no-data>
              <no-results />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <v-container class="pa-0">
      <v-row justify="space-between">
        <v-col class="col-button">
          <v-btn text color="default" @click="previous">
            Anterior
          </v-btn>
        </v-col>
        <v-col class="col-button">
          <v-btn class="ml-auto" color="secondary" @click="next">
            Próximo
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <dialog-price
      :dialogChild="dialogPrice"
      @closeChild="closePrice"
      @saveChild="savePrice"
    />
    <dialog-save
      :dialogChild="dialogSave"
      :projectId="project.id"
      @closeChild="closeSave"
      @confirmChild="saveProjectConfirm"
    />
  </div>
</template>

<script>
import NoResults from '@/components/NoResults';
import api from '@/services/api';
import getErrorMessage from '@/utils/getErrorMessage';
import Hash from 'object-hash';
import DialogSave from './dialog-save';
import DialogPrice from './dialog-price';

export default {
  components: { DialogPrice, DialogSave, NoResults },

  data: () => ({
    dialogPrice: false,
    dialogDelete: false,
    dialogSave: false,
    headers: [
      {
        text: 'Objeto',
        align: 'start',
        sortable: false,
        value: 'object',
      },
      { text: 'Quantidade', value: 'quantity' },
      { text: 'Valor Unitário', value: 'unitPrice' },
      { text: 'Valor Total', value: 'totalPrice' },
      { text: 'Ação', align: 'center', value: 'actions', sortable: false },
    ],
    project: {},
    prices: [],
    editedIndex: -1,
    editedItem: {
      id: null,
      object: '',
      quantity: null,
      unitPrice: null,
    },
    defaultItem: {
      id: null,
      object: '',
      quantity: null,
      unitPrice: null,
    },
    disabledButton: false,
    totalPriceThreshold: 300000,
  }),

  computed: {
    projectTotalPrice() {
      return this.prices.reduce((total, price) => {
        const itemTotal = parseInt(price.quantity, 10) * parseFloat(price.unitPrice);
        return total + itemTotal;
      }, 0);
    },
  },

  watch: {
    dialogDelete(val) {
      return val || this.closeDelete();
    },
    projectTotalPrice() {
      this.checkTotalPrice();
  },
  },

  methods: {
    deleteItem(item) {
      this.editedIndex = this.prices.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.closeDelete();
      this.deletePrice(this.editedItem);
      this.prices.splice(this.editedIndex, 1);
    },
    async deletePrice(item) {
      try {
        this.$store.dispatch('loading', true);

        if (item.id) {
          await api.delete(`/projects/price/${item.id}`);
        }

        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: 'Valor apagado com sucesso',
        });
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    closePrice() {
      this.dialogPrice = false;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    closeSave() {
      this.dialogSave = false;
    },
    savePrice(item) {
      const savedItem = { ...item };
      this.prices.push(savedItem);
    },
    saveProjectConfirm() {
      this.dialogSave = false;
      this.project.totalPrice = this.projectTotalPrice;
      const payload = { project: this.project, next: true };
      this.$emit('saveProject', payload);
    },
    checkChanges() {
      const { originalProject } = this.$store.state;
      const { originalPrices } = this.$store.state;
      const { originalFiles } = this.$store.state;

      return (
        Hash(originalProject) !== Hash(this.project) ||
        Hash(originalPrices) !== Hash(this.project.prices) ||
        Hash(originalFiles) !== Hash(this.project.files)
      );
    },
    next() {
      if (this.checkChanges()) {
        this.dialogSave = true;
        return;
      }
      this.project.totalPrice = this.projectTotalPrice;
      this.$store.dispatch('editProject', this.project);
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    checkTotalPrice() {
      this.disabledButton = this.projectTotalPrice >= this.totalPriceThreshold;
    },
  },

  created() {
    this.project = this.$store.state.project;
    this.prices = this.project.prices || [];
  },
};
</script>

<style scoped>
form p {
  margin-bottom: 8px;
}
.col-button {
  flex-grow: unset;
  padding: 0 16px 16px;
}
</style>
